import { create } from 'zustand';
import useCart from '../../../../hooks/useCart';
import { TEST_COLLECTIONS } from '../../labtest/constants';

const ORDER_DATA = {
    patientName: '',
    patientNumber: '',
    patientAge: '',
    prescription: '',
};

const useTestCartDataStore = create((set) => ({
    ...ORDER_DATA,
    updateCartOrderData: (cartData) => set(state => ({...state, ...cartData})),
    resetCartOrderData: () => set(state => ({...state, ...ORDER_DATA})),
}));

const useTestCartData = () => {
    const {cart, orderInfo} = useCart();
    const { patientAge, patientName, patientNumber, prescription, updateCartOrderData, resetCartOrderData } = useTestCartDataStore();
    const cartPrice = cart.reduce((acc, curr) => +curr.price + acc, 0);
    const serviceType = Object.hasOwn(orderInfo, 'collectionType') ? TEST_COLLECTIONS.find(coll => coll.value === orderInfo.collectionType).name || '' : '';

    return { cart, orderInfo, cartPrice, serviceType, patientAge, patientName, patientNumber, prescription, updateCartOrderData, resetCartOrderData };
};

export default useTestCartData;